module.exports = __webpack_public_path__ + "img/dont-know-ticket.78ce2b78.svg";